"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Table_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Table"));
var Row_1 = __importDefault(require("./Row/Row"));
var HeaderCell_1 = __importDefault(require("./HeaderCell/HeaderCell"));
var Body_1 = __importDefault(require("./Body/Body"));
var Cell_1 = __importDefault(require("./Cell/Cell"));
var Footer_1 = __importDefault(require("./Footer/Footer"));
var Header_1 = __importDefault(require("./Header/Header"));
/**
 * The Table component is used to display complex information in a concise, easy-to-read format which enables the user to take appropriate actions.
 * @child ./Header/Header.tsx
 * @child ./HeaderCell/HeaderCell.tsx
 * @child ./Body/Body.tsx
 * @child ./Row/Row.tsx
 * @child ./Cell/Cell.tsx
 * @child ./Footer/Footer.tsx
 */
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Table.prototype.render = function () {
        return (React.createElement(Table_1.default, __assign({ striped: true }, this.props), this.props.children));
    };
    Table.HeaderCell = HeaderCell_1.default;
    Table.Row = Row_1.default;
    Table.Body = Body_1.default;
    Table.Cell = Cell_1.default;
    Table.Footer = Footer_1.default;
    Table.Header = function (props) { return (React.createElement(Header_1.default, null,
        React.createElement(Row_1.default, null, props.children))); };
    return Table;
}(react_1.Component));
exports.default = Table;
